import React from 'react'
import Dialog from '../../../../dialog/Dialog'
import useFetchData from '../../../../../hooks/useFetchData'
import UserFormSkeleton from '../../../../skeleton/UserFormSkeleton'
import { updateUsersPreview } from '../../../../../store/actions/user.actions'
import { useDispatch, useSelector } from 'react-redux'
import ErrorBoundary from '../../../../ErrorBoundary/ErrorBoundary'

const UserPreview = () => {
  const preview = useSelector((state) => state?.user?.preview || null)

  const dispatch = useDispatch()
  const { isLoading, data, error } = useFetchData(`user/${preview}`);

  const onClose = () => {
    dispatch(updateUsersPreview())
  }
  if (!preview) return <></>

  return (
    <Dialog
      id="user-preview"
      show={!!preview} 
      title="user preview"
      onClose={onClose}
      onCloseHeader={true}
      maxWidth='md'
    >
      { error ?
        <ErrorBoundary />
      : <UserFormSkeleton
          isLoading={isLoading}
          form={data || {}}
        /> 
      }
    </Dialog>
  )
}

export default UserPreview